import { render } from "./CertificateOzon.vue?vue&type=template&id=10263747&scoped=true"
import script from "./CertificateOzon.vue?vue&type=script&lang=js"
export * from "./CertificateOzon.vue?vue&type=script&lang=js"

import "./CertificateOzon.vue?vue&type=style&index=0&id=10263747&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10263747"]])

export default __exports__